import { FeePaymentType, FeeType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { optionalStringToNumber, requiredEnum, requiredNumber, requiredString } from '@/utils/zodUtils';

export const PricingSpecDataFormSchema = (t) =>
  z
    .object({
      minPrincipal: requiredString(t),
      maxPrincipal: requiredString(t),
      minTerm: requiredNumber(t),
      maxTerm: requiredNumber(t),
      annualInterest: requiredString(t),
      merchantDiscountPercentage: requiredString(t),
      setupFeePaymentType: requiredEnum(FeePaymentType, t),
      setupFeeType: requiredEnum(FeeType, t),
      setupFeeValue: requiredString(t),
      gracePeriod: z.number().optional(),
      gracePercentage: z.string().optional(),
      merchantFeeType: z.nativeEnum(FeeType).optional(),
      merchantFeeValue: z.string(t).optional(),
      yearsSinceAutoRegistrationMin: optionalStringToNumber(t, 0),
      yearsSinceAutoRegistrationMax: optionalStringToNumber(t, 1),
    })
    .strict()
    .refine((data) => !(Number(data.minPrincipal) < 0), {
      message: t('AMOUNT_MUST_BE_POSITIVE'),
      path: ['minPrincipal'],
    })
    .refine((data) => !(Number(data.maxPrincipal) < 0), {
      message: t('AMOUNT_MUST_BE_POSITIVE'),
      path: ['maxPrincipal'],
    })
    .refine((data) => !(Number(data.annualInterest) < 0), {
      message: t('AMOUNT_MUST_BE_POSITIVE'),
      path: ['annualInterest'],
    })
    .refine((data) => !(Number(data.merchantDiscountPercentage) < 0), {
      message: t('AMOUNT_MUST_BE_POSITIVE'),
      path: ['merchantDiscountPercentage'],
    });

export type PricingSpecDataFormType = z.infer<ReturnType<typeof PricingSpecDataFormSchema>>;
